import React from "react";

export function ProductsPage() {
  return <></>;
}
